import React from "react";
import { useSelector } from "react-redux";
import MyDependentsEditMember from "./MyDependentsEditMember";
const MyDependentsAccordion = (props) => {
  const { familyMembersList } = props;

  return (
    <>
      <div className="accordion my-dependence-accordion" id="accordionExample">
        {familyMembersList &&
          Array.isArray(familyMembersList) &&
          familyMembersList.length > 0 &&
          familyMembersList.map((familyMember, index) => {
            return (
              <div key={index.toString()} className="accordion-item">
                <h2
                  className="accordion-header"
                  id={"headingOne" + index.toString()}
                >
                  <div className="accordion-action-buttons d-flex justify-content-between w-100">
                    <button
                      className="tab-focusable-background accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={"#collapseOne" + index.toString()}
                      aria-expanded="true"
                      aria-controls={"collapseOne" + index.toString()}
                    >
                      {/* <!-- Tony Doe -->
                                            <!-- <span className="ps-1">(Son)</span> --> */}
                      <div className="family-member">
                        {familyMember.fullName}
                      </div>
                    </button>
                    <div className="accordion-action-btn me-1">
                      <button
                        type="button"
                        className="tab-focusable-background edit btn btn-primary btn-xs interactive-sizing "
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapseOne" + index.toString()}
                        aria-expanded="false"
                        aria-controls={"collapseOne" + index.toString()}
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </h2>
                <div
                  id={"collapseOne" + index.toString()}
                  className="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {/* Edit Member */}
                    <MyDependentsEditMember dependentMember={familyMember} />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default MyDependentsAccordion;
